import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Button } from 'react-bootstrap';

interface EditButtonComponentProps {
  onClick: () => void;
}

const EditButtonComponent: React.FC<EditButtonComponentProps> = ({ onClick }) => {
  return (
    <>
      <Button variant='light' onClick={onClick}>
        <FontAwesomeIcon icon={faEdit} color='#699BF7' />
      </Button>
    </>
  )
}

export default EditButtonComponent;